import { render } from "./AlSandwich.vue?vue&type=template&id=3bfa618e&scoped=true"
import script from "./AlSandwich.vue?vue&type=script&lang=js"
export * from "./AlSandwich.vue?vue&type=script&lang=js"

import "./AlSandwich.vue?vue&type=style&index=0&id=3bfa618e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bfa618e"]])

export default __exports__